var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedeem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 9.91667C1.16675 11.2053 2.21142 12.25 3.50008 12.25H10.5001C11.7887 12.25 12.8334 11.2053 12.8334 9.91667V9.33333C12.8334 9.01117 12.5651 8.75952 12.2606 8.65412C11.5754 8.41689 11.0834 7.7659 11.0834 7C11.0834 6.2341 11.5754 5.58311 12.2606 5.34588C12.5651 5.24048 12.8334 4.98883 12.8334 4.66667V4.08333C12.8334 2.79467 11.7887 1.75 10.5001 1.75H3.50008C2.21142 1.75 1.16675 2.79467 1.16675 4.08333V4.66667C1.16675 4.98883 1.43508 5.24048 1.73952 5.34588C2.42473 5.58311 2.91675 6.2341 2.91675 7C2.91675 7.7659 2.42473 8.41689 1.73952 8.65412C1.43508 8.75952 1.16675 9.01117 1.16675 9.33333V9.91667Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 5.25002C5.83341 5.57219 5.57225 5.83335 5.25008 5.83335C4.92792 5.83335 4.66675 5.57219 4.66675 5.25002C4.66675 4.92785 4.92792 4.66669 5.25008 4.66669C5.57225 4.66669 5.83341 4.92785 5.83341 5.25002Z",
    fill: "#EC421C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 8.75002C9.33341 9.07219 9.07225 9.33335 8.75008 9.33335C8.42792 9.33335 8.16675 9.07219 8.16675 8.75002C8.16675 8.42785 8.42792 8.16669 8.75008 8.16669C9.07225 8.16669 9.33341 8.42785 9.33341 8.75002Z",
    fill: "#EC421C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.25L5.25 8.75",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.d639448dc39266de1406166664c64ab6.svg";
export { ForwardRef as ReactComponent };